module.exports = __webpack_public_path__ + "static/media/brandSpotlight.b1c3d37d.png";